<div class="row">
    <div class="container-fluid pl-0 pr-0">
        <div class="row">
            <div class="col-xl-12">
                <div class="card card-header-actions mx-auto">
                    <div class="card-header">Comp Off Approval Rejection
                    </div>
                    <div class="card-body">
                        <form [formGroup]="compOffForm">
                            <div class="row ">
                                <div class="container">

                                    <div class="row ">
                                        <div class='col-md-3'>
                                            <div class="form-group">
                                                <div class='date' id='datetimepicker6'>
                                                    <label class="control-label">From Date <span
                                                            class="text-danger">*</span> </label>
                                                    <div>
                                                        <input id="from_date" name="from_date" type="text"
                                                            autocomplete="off" onpaste="return false" placeholder="From"
                                                            bsDatepicker #dp="bsDatepicker" (focus)="dp.show()"
                                                            (focus)="dp1.hide()" formControlName="from_date"
                                                            [maxDate]="max_date" onkeypress='return event.charCode == 8'
                                                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false }"
                                                            [ngClass]="{ 'is-invalid': submitted && f.from_date.errors }"
                                                            class="form-control form-control-sm">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class='col-md-3'>
                                            <div class="form-group">
                                                <div class='date' id='datetimepicker7'>
                                                    <label class="control-label">To Date <span
                                                            class="text-danger">*</span> </label>
                                                    <div>
                                                        <input id="to_date" name="to_date" type="text"
                                                            autocomplete="off" onpaste="return false" placeholder="To"
                                                            bsDatepicker formControlName="to_date"
                                                            [minDate]="f.from_date.value" [maxDate]="max_date"
                                                            (focus)="dp.hide()" bsDatepicker #dp1="bsDatepicker"
                                                            (focus)="dp1.show()"
                                                            [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers: false}"
                                                            [ngClass]="{ 'is-invalid': submitted && f.to_date.errors }"
                                                            class="form-control form-control-sm"
                                                            onkeypress='return event.charCode == 8'>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="control-label">Status</label>
                                            <select class="form-control form-control-sm" formControlName="status">
                                                <option value="">Select</option>
                                                <option *ngFor="let item of statusList" [value]="item.id">
                                                    {{item.status_type}}</option>

                                            </select>
                                        </div>
                                        <div class='col-md-3' style="margin-top: 2rem;">
                                            <button type="submit" class="btn btn-sm btn-primary" value="Submit"
                                                (click)="LoadData(0)">Submit</button>&nbsp;&nbsp;
                                            <button type="button" class="btn btn-sm btn-danger">Clear</button>
                                            &nbsp;&nbsp;&nbsp;
                                        </div>
                                        <div class="col-xl-9 mt-4">
                                            <button type="button" class="btnExcel" (click)="downLoadListExcel()"> <i
                                                    class="fa fa-file-excel-o"></i>&nbsp;Excel</button>
                                            <!-- <button type="button"  class="btn btn-sm btn-info"  (click)="downLoadExcel()"> <i class="fa fa-file-excel"></i>&nbsp; Excel</button> -->
                                        </div>
                                        <div class="col-xl-3">
                                            <label>Search</label>
                                            <input type="text" [(ngModel)]="search_string"
                                                [ngModelOptions]="{standalone: true}"
                                                class="form-control form-control-sm" maxlength="50" ngMaxlength=50
                                                value="{{search_string}}" (input)="LoadData(0)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div class="table-responsive mt-4">
                            <table class="table table-striped table-bordered table-sm" style="width:100%">
                                <thead class="text-center">
                                    <tr>
                                        <th class="singleLine">S No</th>
                                        <th class="singleLine">Employee Name</th>
                                        <th class="singleLine">Duration</th>
                                        <th class="singleLine">Comp Off Date</th>
                                        <th class="singleLine" style="white-space: nowrap;">Applied On</th>
                                        <th class="singleLine">Approved/Rejected By</th>
                                        <th class="singleLine" style="white-space: nowrap;">Action Date</th>
                                        <th class="singleLine">Status</th>
                                        <th class="singleLine">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of lstGrid;let i =index">
                                        <td>{{i+1}}</td>
                                        <td>{{item?.user_name}}</td>
                                        <td>{{item?.duration}}</td>
                                        <td>{{item?.comp_off_date | date:'dd-MM-yyyy'}}</td>
                                        <td>{{item?.created_on | date :'dd-MM-yyyy'}}</td>
                                        <td>{{item?.approved_by_name}}</td>
                                        <td>{{item?.approved_date | date : 'dd-MM-yyyy'}}</td>
                                        <td [ngClass]="{
                                            'text-success': item?.status_type?.toLowerCase() === 'approved',
                                            'text-danger': item?.status_type?.toLowerCase() === 'rejected',
                                            'text-warning': item?.status_type?.toLowerCase() === 'pending'
                                          }">
                                            {{ item?.status_type }}
                                        </td>
                                        <td>
                                            <div class="d-flex align-items-center gap-2" *ngIf="item?.status == 1">
                                                <button class="btn btn-sm btn-primary"
                                                    (click)="updateData(item,2)">Approve</button>&nbsp;&nbsp;
                                                <button class="btn btn-sm btn-danger"
                                                    (click)="updateData(item,3)">Reject</button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot *ngIf="lstGrid.length == 0">
                                    <tr>
                                        <td colspan="12" style="text-align: center;background-color: #f2f2f2;">No Records Found</td>
                                    </tr>

                                </tfoot>
                            </table>
                            <div class="row">
                                <div class="col-sm-12 col-md-5">
                                    <div>
                                        Showing {{(rowIndex+1)}} to {{(rowIndex+lstGrid.length)}} of
                                        {{totalElements}} entries.
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-7">
                                    <div>
                                        <nav aria-label="Page navigation example">
                                            <ul class="pagination justify-content-end">
                                                <li class="page-item" *ngIf="PrevpageNumber >= 0"><a class="page-link"
                                                        (click)="LoadData(PrevpageNumber)"
                                                        style="cursor:pointer"><span>Previous</span></a></li>
                                                <li class="page-item active" aria-current="page"
                                                    *ngIf="NextpageNumber > 0"><a class="page-link "
                                                        (click)="LoadData(NextpageNumber)"
                                                        style="cursor:pointer"><span>Next</span></a></li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>